import type { StructuredReportResponse } from "../hooks/useReportQuery";

/** Every fresh report consumer must cross this boundary before using template defaults.
 * Saved editor documents have their own source of truth and bypass generation. */
export function isWordingReady(wording: StructuredReportResponse["meta"]["wording"]) {
  return wording?.state === "ready" || wording?.state === "disabled";
}

export function requireReadyWording(wording: StructuredReportResponse["meta"]["wording"]) {
  if (!isWordingReady(wording)) {
    throw new Error("This draft could not be prepared. The source findings remain available.");
  }
}
